// extracted by mini-css-extract-plugin
module.exports = {"tabGroup":"TabGroup_tabGroup__ITezJ","tabGroup--primary":"TabGroup_tabGroup--primary__wB551","triggers":"TabGroup_triggers__EwJhk"};